import { render, staticRenderFns } from "./student_grade_category.vue?vue&type=template&id=d55eab74&scoped=true&"
import script from "./student_grade_category.vue?vue&type=script&lang=js&"
export * from "./student_grade_category.vue?vue&type=script&lang=js&"
import style0 from "./student_grade_category.vue?vue&type=style&index=0&id=d55eab74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55eab74",
  null
  
)

export default component.exports